/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <v-card>
    <v-data-table :headers="headers" :items="data" hide-actions class="elevation-1">
      <template slot="items" slot-scope="myprops">
        <td
          v-for="header in headers"
          class="text-xs-left"
        >{{ myprops.item[header.value] ? myprops.item[header.value] : '---' }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  props: ["headers", "data"]
};
</script>

